



















import Vue from "vue";
import { Component } from "vue-property-decorator";
import FontAwesomeIcon from "@/components/FontAwesomeIcon.vue";
@Component({ components: { FontAwesomeIcon } })
export default class GridLoadingOverlay extends Vue {}
